// @ts-nocheck
import * as React from "react"
import CardBlog from "./CardBlog"
import * as Macy from "macy"
import * as AOS from 'aos'

export default ({ articleList, btnMore }: ArticleCmp) => {

    function MacyInstance() {
        const macyInstance = Macy({
            container: '.card-block',
            trueOrder: true,
            columns: 3,
            margin: {
                x: 40,
                y: 50,
            },
            waitForImages: false,
            useOwnImageLoader: false,
            mobileFirst: false,
            breakAt: {
                1200: 1
            }
        });
    }


    React.useEffect(() => {
        MacyInstance()
        AOS.refresh()
    });

    return (
        <div className='card-block'>
            {articleList.map((article: BlogArticles, index: number) => (
                <CardBlog key={index} data={article} btnMore={btnMore} />
            ))}
        </div>
    )
}